import { Theme } from '@ifit/themes/ThemeContext';
import { render } from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './app';
import './index.scss';
import './native-interactions';
import { queryClient } from './state-management/server-state/query-client';
import { store } from './state-management/store';
import { runDatadog } from './datadog-setup';

const element = document.getElementById('root') || document.createElement('div');

export function Index(): JSX.Element {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Theme>
          <App />
        </Theme>
        <ToastContainer newestOnTop={true} draggable={false} closeOnClick={false} />
        {process.env.NODE_ENV !== 'test' ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </QueryClientProvider>
    </Provider>
  );
}

render(<Index />, element);
runDatadog();
